import React from "react";

const faqData = [
  {
    question: "What services does CaptureEdits offer?",
    answer:
      "We provide professional photo editing, video editing, album design, and photo culling services. Our work includes color correction, retouching, background removal, highlight reels, and more.",
  },
  {
    question: "How do I get started?",
    answer:
      "Simply go to the Get Started page, upload your files via Google Drive, Dropbox, or WeTransfer, choose your service, and our team will begin work on your project",
  },
  {
    question: "Who edits my files?",
    answer:
      "All editing is done manually by our team of experienced professionals — no AI filters or automated software.",
  },
  {
    question: "Do you offer a free sample edit?",
    answer:
      "Yes! We offer free test edits so you can review our quality before committing to a full project.",
  },
  {
    question: "How long does editing take?",
    answer:
      "Turnaround is usually 24–48 hours depending on the size of the project.",
  },
  {
    question: "How will I receive my final files?",
    answer:
      "Final files will be delivered via secure download links (One Drive, Dropbox, or WeTransfer).",
  },
  {
    question: "Do you offer discounts for bulk orders?",
    answer:
      "Yes, we provide special pricing for high-volume clients, studios, and agencies.",
  },
  {
    question: "What if I'm not satisfied with the edits?",
    answer:
      "We offer free revisions until you're 100% happy with the results. Just let us know what you'd like adjusted.",
  },
  {
    question: "Is support available after delivery?",
    answer:
      "Yes! We offer responsive post-delivery support for any changes, questions, or technical help.",
  },
];

const Faqs = () => {
  return (
    <div className="bg-light">
      <div className="container py-5">
        <div className="row align-items-center">
          <div className="col-md-5">
            <p className="text_maincolor text-center fw-600">FAQs</p>
            <h1 className="display-6 fw-600 text-center mb-4 amaranth-regular">
              Find Answers to Common Questions
            </h1>
          </div>
          <div className="col-md-7">
            <div
              className="accordion accordion-flush"
              id="accordionFlushExample"
            >
              {faqData.map((faq, index) => (
                <div className="accordion-item bg-transparent" key={index}>
                  <h2
                    className="accordion-header"
                    id={`flush-heading-${index}`}
                  >
                    <button
                      className="accordion-button collapsed shadow-none bg-transparent fw-600"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#flush-collapse-${index}`}
                      aria-expanded="false"
                      aria-controls={`flush-collapse-${index}`}
                    >
                      {faq.question}
                    </button>
                  </h2>
                  <div
                    id={`flush-collapse-${index}`}
                    className="accordion-collapse collapse"
                    aria-labelledby={`flush-heading-${index}`}
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">{faq.answer}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faqs;
